import { GeneralToggle } from '../../../../general';

const Freshness = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ALL: 'all',
  FORGOTTEN: 'forgotten',
}

const FreshnessToggle = ({ freshness, setFreshness }) => {
  return (
    <GeneralToggle 
      label='Freshness' 
      value={freshness} 
      setValue={setFreshness}
      items={Object.values(Freshness).filter(value => value !== Freshness.FORGOTTEN)}
    />
  );
};

export default FreshnessToggle;

export {
  Freshness,
}